import { useEffect } from "react";

export default function useStartup(startupCallback: React.EffectCallback, shutdownCallback?: () => void) {
    useEffect(() => { 
        startupCallback(); 
        return shutdownCallback;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export function useShutdown(shutdownCallback: () => void) {
    useEffect(() => { 
        return shutdownCallback; 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}